import RightRail from '../../libs/gs-component-right-rail';
import React from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';

import { websiteSettingsRoute } from '../../helpers/routes';

import { SettingsRailContent } from './SettingsRailContent';

export const SettingsRail: React.FC = () => {
  const match = useRouteMatch(websiteSettingsRoute);
  const history = useHistory();

  const onClose = () => {
    history.push('/gs/dashboard');
  };

  return (
    <>
      <RightRail open={!!match} onEscapeKey={onClose}>
        <SettingsRailContent onClose={onClose} />
      </RightRail>
    </>
  );
};
